import React from 'react';
import { X, ExternalLink } from 'lucide-react';
import type { LinkPreviewData } from './UselinkPreview';

// ── Preview card shown above the input bar while composing ──
interface InputPreviewProps {
  preview: LinkPreviewData;
  loading?: boolean;
  onDismiss: () => void;
}

export const InputLinkPreview: React.FC<InputPreviewProps> = ({ preview, onDismiss }) => (
  <div className="lp-input">
    <div className="lp-input__bar" />
    <div className="lp-input__body">
      <div className="lp-input__text">
        <span className="lp-input__site">{preview.siteName}</span>
        <span className="lp-input__title">{preview.title}</span>
        {preview.description && (
          <span className="lp-input__desc">{preview.description}</span>
        )}
      </div>
      {preview.image && (
        <img className="lp-input__img" src={preview.image} alt="" onError={e => (e.currentTarget.style.display = 'none')} />
      )}
    </div>
    <button className="lp-input__close" onClick={onDismiss} title="Quitar preview">
      <X size={14} />
    </button>
  </div>
);

// ── Preview card shown inside a sent/received message bubble ──
interface MsgPreviewProps {
  preview: LinkPreviewData;
  isOut: boolean;
}

export const MsgLinkPreview: React.FC<MsgPreviewProps> = ({ preview, isOut }) => (
  <a
    className={`lp-msg ${isOut ? 'lp-msg--out' : 'lp-msg--in'}`}
    href={preview.url}
    target="_blank"
    rel="noopener noreferrer"
    onClick={e => e.stopPropagation()}
  >
    {preview.image && (
      <img className="lp-msg__img" src={preview.image} alt="" onError={e => (e.currentTarget.style.display = 'none')} />
    )}
    <div className="lp-msg__body">
      <span className="lp-msg__site">{preview.siteName}</span>
      <span className="lp-msg__title">{preview.title}</span>
      {preview.description && (
        <span className="lp-msg__desc">{preview.description}</span>
      )}
      <span className="lp-msg__url">
        <ExternalLink size={10} style={{ marginRight: 3 }} />
        {preview.url.replace(/^https?:\/\//, '').slice(0, 40)}
      </span>
    </div>
  </a>
);